const HeroTertiary = (props) => {

  const {
    items
  } = props

  const normalizedData = {
    items
  }

  return normalizedData
}

export default HeroTertiary
